import { render, staticRenderFns } from "./project-filter.vue?vue&type=template&id=3a122ca2&"
import script from "./project-filter.vue?vue&type=script&lang=js&"
export * from "./project-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports